import { buildApiUrl, API_ENDPOINTS, apiRequest } from '../config/api.js'
import { usersApi } from './users.js'
import { teamsApi } from './teams.js'

export const tasksApi = {
  async getAllTasks() {
    try {
      const url = buildApiUrl(API_ENDPOINTS.TASKS.ALL)
      const response = await apiRequest(url)
      return { data: response.data || [] }
    } catch (error) {
      console.error('Failed to load tasks:', error)
      throw new Error('Unable to load tasks. Please check your connection and try again.')
    }
  },

  async getTasksByUser(userId) {
    try {
      const url = buildApiUrl(API_ENDPOINTS.TASKS.BY_USER(userId))
      const response = await apiRequest(url)
      return { data: response.data || [] }
    } catch (error) {
      console.error('Failed to load user tasks:', error)
      throw new Error('Unable to load your tasks. Please check your connection and try again.')
    }
  },

  async getTasksAssignedByUser(userId) {
    try {
      const url = buildApiUrl(API_ENDPOINTS.TASKS.ASSIGNED_BY_USER(userId))
      const response = await apiRequest(url)
      return { data: response.data || [] }
    } catch (error) {
      console.error('Failed to load assigned tasks:', error)
      throw new Error('Unable to load assigned tasks. Please check your connection and try again.')
    }
  },

  async getTasksByTeam(teamId) {
    try {
      const url = buildApiUrl(API_ENDPOINTS.TASKS.BY_TEAM(teamId))
      const response = await apiRequest(url)
      return { data: response.data || [] }
    } catch (error) {
      console.error('Failed to load team tasks:', error)
      throw new Error('Unable to load team tasks. Please check your connection and try again.')
    }
  },

  async createTask(taskData) {
    try {
      const url = buildApiUrl(API_ENDPOINTS.TASKS.ALL)
      const response = await apiRequest(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ task: taskData })
      })
      return { data: response.data }
    } catch (error) {
      console.error('Failed to create task:', error)
      throw new Error('Unable to create task. Please check your connection and try again.')
    }
  },

  async updateTask(taskId, updateData) {
    try {
      const url = buildApiUrl(API_ENDPOINTS.TASKS.BY_ID(taskId))
      const response = await apiRequest(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ task: updateData })
      })
      return { data: response.data }
    } catch (error) {
      console.error('Failed to update task:', error)
      throw new Error('Unable to update task. Please check your connection and try again.')
    }
  },

  async deleteTask(taskId) {
    try {
      const url = buildApiUrl(API_ENDPOINTS.TASKS.BY_ID(taskId))
      await apiRequest(url, {
        method: 'DELETE'
      })
      return { success: true }
    } catch (error) {
      console.error('Failed to delete task:', error)
      throw new Error('Unable to delete task. Please check your connection and try again.')
    }
  },

  async getUsers() {
    try {
      const response = await usersApi.getUsers()
      return { data: response }
    } catch (error) {
      console.error('Failed to load users:', error)
      throw new Error('Unable to load users. Please check your connection and try again.')
    }
  },

  async getTeams() {
    try {
      const response = await teamsApi.getTeams()
      return { data: response }
    } catch (error) {
      console.error('Failed to load teams:', error)
      throw new Error('Unable to load teams. Please check your connection and try again.')
    }
  },

  async getTeamMembers(teamId) {
    try {
      const response = await teamsApi.getTeamMembers(teamId)
      return { data: response }
    } catch (error) {
      console.error('Failed to load team members:', error)
      throw new Error('Unable to load team members. Please check your connection and try again.')
    }
  }
}

export const TASK_STATUSES = [
  { value: 'pending', label: 'Pending', color: 'yellow' },
  { value: 'in_progress', label: 'In Progress', color: 'blue' },
  { value: 'completed', label: 'Completed', color: 'green' },
  { value: 'cancelled', label: 'Cancelled', color: 'red' }
]

export const TASK_PRIORITIES = [
  { value: 'low', label: 'Low', color: 'gray' },
  { value: 'medium', label: 'Medium', color: 'yellow' },
  { value: 'high', label: 'High', color: 'red' }
]